import { useCallback } from 'react';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { InsertItemLayout } from '../InsertItemLayout/InsertItemLayout';
import { useAssetEditorsContext } from '../../../context/AssetEditorsContextProvider';
import { useAssetViewContext } from 'screens/editorial/asset/context/AssetViewContextProvider';

export const SubheadlineOption = () => {
  const { setSubheadlineHidden } = useAssetViewContext();
  const { subheadlineEditor } = useAssetEditorsContext();

  // reveal, scroll to, focus, and set cursor subheadline
  const revealSubheadline = useCallback(() => {
    if (!subheadlineEditor) return;
    setSubheadlineHidden(false);
    requestAnimationFrame(() => {
      subheadlineEditor?.chain().focus().run();
    });
  }, [subheadlineEditor, setSubheadlineHidden]);

  return (
    <InsertItemLayout
      id="widget-select-subheadline"
      title="Subheadline"
      icon={<ViewHeadlineIcon />}
      description="Elaborates on the main headline, offering more details about the story."
      action={revealSubheadline}
    />
  );
};
